import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const FestiveRibbon = () => (
  <motion.section
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
    className="border-b border-brand-border bg-[#FBEAE4]"
    data-testid="festive-ribbon"
  >
    <Link
      to="/festivals"
      data-testid="festive-ribbon-link"
      className="group mx-auto flex max-w-7xl flex-col items-center justify-center gap-2 px-6 py-8 text-center sm:flex-row sm:gap-4 lg:px-12"
    >
      <span className="font-display text-xl italic text-[#9C2B1B] md:text-2xl">
        उत्सव आ रहे हैं — Festive Specials for Durga Pooja, Karwa Chauth & Diwali
      </span>
      <span className="inline-flex items-center gap-2 rounded-full border border-[#9C2B1B]/40 px-5 py-1.5 text-[10px] font-medium uppercase tracking-[0.25em] text-[#9C2B1B] transition-colors duration-300 group-hover:bg-[#9C2B1B] group-hover:text-white">
        Explore
        <ArrowRight className="h-3 w-3 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
      </span>
    </Link>
  </motion.section>
);
